module.exports = __webpack_public_path__ + "static/media/Benjamin.68db0386.jpg";